import './index.scss'
import { Link } from 'react-router-dom'
import projects from '../../data/projects'
import { skills } from '../../data/skills'
import ProjectPreview from '../ProjectPreview'
import bhamLogo from '../../assets/images/bham_logo.png'

const HomePage = () => {
  const visible = projects.filter((p) => p.visible)
  const selected = visible.filter((p) => p.featured).slice(0, 2)

  return (
    <main className="home-page">
      <div className="site-container">
      <section className="hero">
        <div className="hero__content">
          <p className="eyebrow">Welcome</p>
          <h1>Christian Turner-Jones</h1>
          <h2>B.Sc Computer Science Graduate</h2>
          <p className="hero__text">
            I am a Computer Science graduate from the University of Birmingham with a 2:1 degree and practical experience building software across artificial intelligence, networking, full-stack web development, and distributed systems. My work has involved Java, Python, TypeScript, SQL, machine learning, databases, and modern software engineering practices.
          </p>
          <div className="hero__actions">
            <Link to="/about" className="btn btn--primary">Learn More</Link>
            <Link to="/contact" className="btn btn--secondary">Contact Me</Link>
          </div>
        </div>
      </section>

      <section id="about" className="content-section">
        <div className="section-heading">
          <h3>Education & Background</h3>
          <Link to="/about" className="btn btn--secondary see-more">See more</Link>
        </div>
        <p>
          BSc Computer Science graduate from the University of Birmingham with a 2:1 degree. My studies included data structures and algorithms, object-oriented programming, full-stack development, operating systems, networks, security, artificial intelligence, NLP, and computer vision.
        </p>
        <p>
          I studied A-levels in Computer Science, Mathematics, and Physics at Cowbridge School, achieving A* grades in all three subjects. I have practical experience building software across AI, networking, full-stack web development, and distributed systems. 
        </p>
      </section>

      <section id="skills" className="content-section">
        <div className="section-heading">
          <h3>Key Skills</h3>
          <Link to="/skills" className="btn btn--secondary see-more">See more</Link>
        </div>
        <div className="cards">
          {(
            // Prefer explicitly featured categories, fall back to first three
            (skills.filter((g) => g.featured).length ? skills.filter((g) => g.featured) : skills.slice(0, 3)).slice(0, 3)
          ).map((group) => (
            <article className="card card--skills" key={group.category}>
              <h4>{group.category}</h4>
              <ul>
                {group.items.slice(0, 4).map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </section>

      <section id="projects" className="content-section">
        <div className="section-heading">
          <h3>Selected Projects</h3>
          <Link to="/projects" className="btn btn--secondary see-more">See more</Link>
        </div>
        <div className="cards cards--projects">
          {selected.map((p) => (
            <ProjectPreview
              key={p.slug}
              title={p.title}
              excerpt={p.description}
              to={`/projects/${p.slug}`}
              image={p.image || bhamLogo}
            />
          ))}
        </div>
      </section>
      </div>
    </main>
  )
}

export default HomePage
